import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Navigation from "./components/Navigation";
import Hero from "./components/Hero";
import FeaturedFilms from "./components/FeaturedFilms";
import Categories from "./components/Categories";
import About from "./components/About";
import Process from "./components/Process";
import Team from "./components/Team";
import InstagramStrip from "./components/InstagramStrip";
import ClientLogos from "./components/ClientLogos";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import GrainOverlay from "./components/GrainOverlay";
import ScrollToTop from "./components/ScrollToTop";
import AdminPage from "./admin/AdminPage";
import AdFilmsPage from "./pages/AdFilmsPage";

const Home = () => {
  return (
    <main data-testid="home-page" className="relative">
      <Navigation />
      <Hero />
      <FeaturedFilms />
      <Categories />
      <About />
      <Process />
      <Team />
      <InstagramStrip />
      <ClientLogos />
      <FAQ />
      <Contact />
      <Footer />
      <GrainOverlay />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            color: "#ffffff",
            border: "1px solid rgba(255,255,255,0.15)",
            borderRadius: 0,
            fontFamily: "Inter, sans-serif",
            fontSize: "13px",
            letterSpacing: "0.02em",
          },
        }}
      />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/films" element={<AdFilmsPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
